import React, { Fragment } from 'react';
import { useTheme } from 'ThemeContext';

import {
  Wrapper,
  Item,
  ItemExternal,
  Title,
  Icon
} from './ToolbarSettings.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import WidgetHTML from '../../Widgets/WidgetHTML';
import WidgetDisabledFacilities from '../../Widgets/WidgetDisabledFacilities';

function ToolbarSettings({ widgets = [] }) {
  const theme = useTheme();

  const renderItemInner = widget => {
    return (
      <>
        {widget.data.icon ? (
          <Icon size={widget.data.size}>
            <FontAwesomeIcon icon={widget.data.icon.split(',')} />
          </Icon>
        ) : (
          <Title>{widget.data.title}</Title>
        )}
      </>
    );
  };

  return (
    <Wrapper>
      {widgets &&
        widgets
          .filter(
            widget =>
              ((widget.widget_id === 3 ||
                widget.widget_id === 4 ||
                widget.widget_id === 5) &&
                widget.data) ||
              widget.widget_id === 14
          )
          .map((widget, key) => (
            <Fragment key={key}>
              {widget.widget_id === 3 || widget.widget_id === 4 ? (
                (widget.data.slug &&
                  /(http(s?)):\/\//gi.test(widget.data.slug)) ||
                (widget.data.link &&
                  /(http(s?)):\/\//gi.test(widget.data.link)) ||
                (widget.data.url &&
                  /(http(s?)):\/\//gi.test(widget.data.url)) ||
                widget.data.url_outside ? (
                  <ItemExternal
                    aria-label={` link ${widget.data.slug ||
                      widget.data.link ||
                      widget.data.url ||
                      widget.data.url_outside}`}
                    theme={theme.toolbarSettings.item}
                    title={widget.data.title}
                    href={
                      widget.data.slug ||
                      widget.data.link ||
                      widget.data.url ||
                      widget.data.url_outside
                    }
                    target={
                      widget.data._blank ||
                      widget.data.link_blank ||
                      widget.data.url_blank ||
                      widget.data.url_outside_blank
                        ? '_blank'
                        : '' || widget.data.target || ''
                    }
                    rel={
                      widget.data.nofollow ||
                      widget.data.link_nofollow ||
                      widget.data.url_nofollow ||
                      widget.data.url_outside_nofollow
                        ? 'nofollow'
                        : '' || widget.data.rel || ''
                    }
                    color={widget.data.color}
                  >
                    {renderItemInner(widget)}
                  </ItemExternal>
                ) : widget.data.slug || widget.data.link ? (
                  <Item
                    aria-label={` link ${widget.data.slug ||
                      widget.data.link ||
                      widget.data.url ||
                      widget.data.url_outside}`}
                    theme={theme.toolbarSettings.item}
                    title={widget.data.title}
                    smooth
                    to={(() => {
                      let slug;
                      if (widget.data.slug)
                        slug =
                          widget.data.slug[0] === '/'
                            ? widget.data.slug
                            : `/${widget.data.slug}`;
                      else if (widget.data.link)
                        slug =
                          widget.data.link[0] === '/'
                            ? widget.data.link
                            : `/${widget.data.link}`;
                      else slug = '';

                      return slug;
                    })()}
                    color={widget.data.color}
                  >
                    {renderItemInner(widget)}
                  </Item>
                ) : (
                  ''
                )
              ) : widget.widget_id === 5 ? (
                <WidgetHTML data={widget.data.text} />
              ) : widget.widget_id === 14 ? (
                <WidgetDisabledFacilities
                  isToolbar={true}
                  themeOverride={theme.toolbarSettings}
                  data={widget.data}
                />
              ) : (
                ''
              )}
            </Fragment>
          ))}
    </Wrapper>
  );
}

export default ToolbarSettings;
